import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import menu from './modules/menu'
import area from './modules/area'
import enums from './modules/enum'
import getters from './getters'
import { baseUrl, apiProxyUrl, maintainUrl } from '@/xhr'
import { role } from '@/lib'
import $ from 'jquery'
import * as http from 'src/lib/http'

// import accountUrl from '@/xhr/services/account'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    menu,
    area,
    enums,
  },
  getters,
  state: {
    count: 1,
    apiUrl: `${baseUrl}:`,
    // rent服务接口地址
    rentUrl: apiProxyUrl + '/rent/',
    // rent 新变更接口地址
    rentLeaseUrl: apiProxyUrl + '/',
    // house房源接口地址
    houseUrl: apiProxyUrl + '/house/',
    // contract合同接口地址
    contractUrl: apiProxyUrl + '/contract/',
    // 推送房管
    pushHomeUrl: apiProxyUrl + '/house_publish/fgj/',
    // account登录接口地址 （修改中）
    accountUrl: apiProxyUrl + '/account/',
    // pdf接口地址
    pdfUrl: apiProxyUrl + '/oss/',
    // pay接口地址
    payUrl: apiProxyUrl + '/pay/',
    // 工作流接口地址
    workflowUrl: baseUrl + ':21600/workflow/',
    maintainUrl: maintainUrl + ':',
    // 售后服务接口地址
    serviceUrl: maintainUrl + ':23300/maintain/',
    // 搜索引擎接口地址
    searchUrl: apiProxyUrl + '/search/',
    // 维修物品接口地址
    categoryUrl: apiProxyUrl + '/data/',
    // 三级联动接口地址
    blockUrl: apiProxyUrl + '/block/',
    // 同步房源数据到蘑菇租房
    alipayUrl: apiProxyUrl + '/house/sync/',
    // 智能门锁
    lockUrl: apiProxyUrl + '/lock/',
    // 修改用户基本信息 （新增） 需要变更 todo
    editorUserMessageUrl: apiProxyUrl + '/modify/',
    adminleftnavnum: '',
    houseleftnavnum: '',
    topIndex: '',
    menuleftnavnum: '',
    serviceleftnavnum: '',
    processKey: {
      maintain: 'PROCESS-KEY-MAINTAIN-V10',
    },
    // 角色数据
    roleData: localStorage.getItem('roleData') || '',
    currentUser: {
      get UserPhone() {
        return localStorage.getItem('currentUserPhone')
      },
      get UserToken() {
        return localStorage.getItem('currentUserToken')
      },
      get keeperData() {
        return localStorage.getItem('keeperData')
      },
      get houseData() {
        return localStorage.getItem('houseData')
      },
      get uid() {
        return localStorage.getItem('uid')
      },
      get username() {
        return localStorage.getItem('username')
      },
      get isGudong() {
        return localStorage.getItem('isGudong')
      },
      get roleData() {
        return localStorage.getItem('roleData')
      },
    },
    searchData: {
      get searchData() {
        return localStorage.getItem('searchData')
      },
      get searchType() {
        return localStorage.getItem('searchType')
      },
      get searchDataId() {
        return localStorage.getItem('searchDataId')
      },
    },
    processInstanceId: '', // 流程id
    taskId: '', // 任务id
    workflowToken: '',
    areaId: '', // 区域选择的id

    sessionId: '', // 接口公用校验参数
    userId: '', // 接口公用校验参数
    accessIp: '', // 接口公用校验参数
  },
  mutations: {
    setAreaId(state, areaid) {
      state.areaId = areaid
    },
    increment(state) {
      state.count++
    },
    // 拿新workflowToken
    getNewWorkflowToken(state, { processKey, processTenantId, variables }) {
      let url = this.state.workflowUrl + 'process/auth/new'
      $.ajax({
        url: url,
        data: JSON.stringify({
          processKey: processKey, // 类似PROCESS-KEY-RENT
          userId: this.state.currentUser.uid, // uid
          processTenantId: processTenantId, // 片区id
          variables: variables, // 可变参数
        }),
        contentType: 'application/json',
        cache: false,
        async: false,
        type: 'POST',
        dataType: 'json',
        success: function(result) {
          state.workflowToken = result.data.workflowToken
          state.processInstanceId = result.data.processInstanceId
          // state.taskId = result.data.taskId
        },
      })
    },
    // 拿中间点workflowToken
    getMidWorkflowToken(state, { processKey, variables }) {
      let url = this.state.workflowUrl + 'process/auth'
      $.ajax({
        url: url,
        data: JSON.stringify({
          processBusinessKey: processKey, // 从里面是业务id
          userId: this.state.currentUser.uid,
          variables: variables,
        }),
        contentType: 'application/json',
        cache: false,
        async: false,
        type: 'POST',
        dataType: 'json',
        success: function(result) {
          state.workflowToken = result.data.workflowToken
          state.processInstanceId = result.data.processInstanceId // 流程实例id
          state.taskId = result.data.taskId
        },
      })
    },
    setUser(state, { userName, userToken, uid, accessIp }) {
      // 在这里把用户名和token保存起来
      localStorage.setItem('currentUserPhone', userName)
      localStorage.setItem('currentUserToken', userToken)
      localStorage.setItem('uid', uid)
      localStorage.setItem('accessIp', accessIp)
    },
    // 添加 cookie
    setCookie(state, { sessionId, ip, userId }) {
      document.cookie = `sessionId=${sessionId}`
      document.cookie = `ip=${ip}`
      document.cookie = `userId=${userId}`
    },
    setUserName(state, { username }) {
      // 在这里把用户名和token保存起来
      localStorage.setItem('username', username)
    },
    setGudong(state, { isGudong }) {
      // 在这里把用户名和token保存起来
      localStorage.setItem('isGudong', isGudong)
    },
    setKeeperData(state, { keeperData }) {
      localStorage.setItem('keeperData', keeperData)
      let keeper = JSON.parse(keeperData)
      for (var i = 0; i <= keeper.length - 1; i++) {
        for (var j = 0; j <= keeper[i].cities.length - 1; j++) {
          if (keeper[i].cities[j].id === this.state.currentUser.uid) {
            localStorage.setItem('role', keeper[i].label)
          }
        }
      }
    },
    setHouseData(state, { houseData }) {
      localStorage.setItem('houseData', houseData)
      let keeper = JSON.parse(houseData)
      for (var i = 0; i <= keeper.length - 1; i++) {
        for (var j = 0; j <= keeper[i].cities.length - 1; j++) {
          if (keeper[i].cities[j].id === this.state.currentUser.uid) {
            localStorage.setItem('role', keeper[i].label)
          }
        }
      }
      // let keeper = JSON.parse(keeperData)
      // for (var i = 0; i <= keeper.length - 1; i++) {
      //   for (var j = 0; j <= keeper[i].cities.length - 1; j++) {
      //     if (keeper[i].cities[j].id === this.state.currentUser.uid) {
      //       localStorage.setItem('role', keeper[i].label)
      //     }
      //   }
      // }
    },
    setSearchData(state, { searchDataId, searchData, searchType }) {
      localStorage.setItem('searchDataId', searchDataId)
      localStorage.setItem('searchData', searchData)
      localStorage.setItem('searchType', searchType)
    },
    // 保存用户角色
    setRoleData(state, { roleData }) {
      state.roleData = roleData
      localStorage.setItem('roleData', roleData)
    },

    // 获取 权限校验 接口公用参数
    setPublicCheckParam(state, { userToken, uid, accessIp }) {
      state.sessionId = userToken
      state.userId = uid
      state.accessIp = accessIp
    },
  },
  actions: {
    // 用户名密码登录
    userLogin(context, { userName, userPass, cb }) {
      let url = this.state.accountUrl + 'work/user/login'
      Vue.http
        .post(url, {
          phone: userName,
          password: userPass,
        })
        .then(
          res => {
            let success = false
            let err = null
            if (res.data.code === 200) {
              const token = res.data.data.sessionId
              const uid = res.data.data.id
              const ip = res.data.data.ip
              if (token !== '') {
                setTimeout(() => {
                  http.bootstrap()
                }, 300)
                
                // 后端API验证通过
                // 调用上面mutations里定义的方法
                context.commit('setPublicCheckParam', {
                  userToken: token,
                  uid,
                  accessIp: ip,
                }) // 在 state 中存储公用参数
                context.commit('setUser', {
                  userName: userName,
                  userToken: token,
                  uid: uid,
                  accessIp: ip,
                })
              }
              context.dispatch('getReportMenu', uid)
              // context.dispatch('getIp') // 调用 同级action中函数 以获取ip
              // router.push({ name: 'tasks' })
              success = true
            } else if (res.data.code === 10007) {
              Vue.prototype.$message({
                message: '用户名或密码错误。',
                type: 'error',
              })
            } else if (res.data.code === 10005) {
              Vue.prototype.$message({
                message: '该用户未注册。',
                type: 'error',
              })
            } else {
              err = new Error(res.data.message)
            }

            typeof cb === 'function' && cb(success, err)
          },
          res => {
            console.log('请求失败进入这里')
          }
        )
    },
    // 通过三方接口 获取当前电脑IP
    getIp(context) {
      let url = 'https://api.ipify.org?format=jsonp&callback=getIP'
      Vue.http
        .get(url)
        .then(res => {
          console.log({
            data: res.data,
            type: typeof res.data,
            ip: res.data.split('"')[3],
          })
          localStorage.setItem('hostIp', res.data.split('"')[3])
          // context.commit('setCookie', {
          //   sessionId: localStorage.getItem('currentUserToken'),
          //   ip: res.data.split('"')[3],
          //   userId: localStorage.getItem('uid'),
          // })
        })
        .catch(() => {
          localStorage.setItem('hostIp', '')
          // context.commit('setCookie', {
          //   sessionId: localStorage.getItem('currentUserToken'),
          //   ip: '',
          //   userId: localStorage.getItem('uid'),
          // })
        })
    },
    // 获取小管家数据
    getKeeperData(context, { keeperData }) {
      // 调用上面mutations里定义的方法
      context.commit('setKeeperData', { keeperData: keeperData })
    },
    // 获取收房专员数据
    getHouseData(context, { houseData }) {
      // 调用上面mutations里定义的方法
      context.commit('setHouseData', { houseData: houseData })
    },
    getSearchData(context, { searchDataId, searchData, searchType }) {
      // 调用上面mutations里定义的方法
      context.commit('setSearchData', {
        searchDataId: searchDataId,
        searchData: searchData,
        searchType: searchType,
      })
    },
    // 获取小管家姓名
    getLoginName(context, { username }) {
      // 调用上面mutations里定义的方法
      context.commit('setUserName', { username: username })
    },
    // 获取小管家姓名
    getGudong(context, { isGudong }) {
      // 调用上面mutations里定义的方法
      context.commit('setGudong', { isGudong: isGudong })
    },
    // 获取角色列表
    getRole(context, { id }) {
      Vue.http
        .get(this.state.accountUrl + 'role/list/u/' + id)
        // accountUrl.getRoleListById(id)
        .then(
          function(response) {
            var data = response.data
            if (data.code === 200) {
              let list = data.data
              let roleData = []
              for (var i = 0; i <= list.length - 1; i++) {
                roleData.push(list[i].name)
              }
              // 保存角色数组
              context.commit('setRoleData', { roleData: roleData })

              const roleList = response.data.data.map(item => item.aliasName)
              // 合作伙伴
              const isGudong = roleList.includes('PARTNER')
              // 调用上面mutations里定义的方法
              if (isGudong) {
                context.commit('setGudong', { isGudong: isGudong })
              } else {
                localStorage.removeItem('isGudong')
              }
              // 小管家
              const isHouseKeeper = roleList.includes('HOUSEKEEPER')
              // 片区负责人
              const isHouseKeeperManager = roleList.includes(
                'HOUSEKEEPER-MANAGER'
              )
              // 公寓事业部经理
              const isHouseKeeperApartment = roleList.includes(
                'HOUSEKEEPER-APARTMENT'
              )

              // 运营部经理
              const isOpenManager = roleList.includes('OPER-MANAGER')
              // 运营主管
              const isOpenExecutive = roleList.includes('OPER-EXECUTIVE')
              // 运营专员
              const isOpenProfessional = roleList.includes('OPER-PROFESSIONAL')

              // 销售专员
              const isNuvotonmcu = roleList.includes('NUVOTONMCU')
              // 销售主管
              const isNuvotonmcuManager = roleList.includes(
                'NUVOTONMCU-MANAGER'
              )
              // 营销部经理
              const isMarketingManager = roleList.includes('MARKETING-MANAGE')

              // 店长
              const isShopOwner = roleList.includes('SHOPOWNER')

              role.setIsHouseKeeper(isHouseKeeper)
              role.setIsHouseKeeperManager(isHouseKeeperManager)
              role.setIsHouseKeeperApartment(isHouseKeeperApartment)
              role.setIsOpenManager(isOpenManager)
              role.setIsOpenExecutive(isOpenExecutive)
              role.setIsOpenProfessional(isOpenProfessional)
              role.setIsNuvotonmcu(isNuvotonmcu)
              role.setIsNuvotonmcuManager(isNuvotonmcuManager)
              role.setIsMarketingManager(isMarketingManager)
              role.setIsShopOwner(isShopOwner)
            }
          },
          function(response) {
            console.log(response.status)
          }
        )
    },
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js